import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

import translationEN from '../../assets/translation/en/translation.json';
import translationES from '../../assets/translation/es/translation.json';
import { BUCKET_URL_BASE_DEV, BUCKET_URL_BASE_PROD, IS_DEV, USE_MOCKS } from '../constants/constants';
import {
  DEFAULT_LANGUAGE_MOCK,
  FALLBACK_LANGUAGE,
  FALLBACK_LANGUAGE_MOCK,
  SUPPORTED_ISO_CODES
} from '../constants/i18n';

const localResources = {
  es: { translation: translationES },
  en: { translation: translationEN }
};

if (USE_MOCKS) {
  i18n
    .use(
      initReactI18next || {
        type: '3rdParty' as const,
        init: () => {
          void 0;
        }
      }
    )
    .init({
      lng: DEFAULT_LANGUAGE_MOCK,
      fallbackLng: FALLBACK_LANGUAGE_MOCK,
      supportedLngs: SUPPORTED_ISO_CODES,
      resources: localResources,
      debug: false,
      compatibilityJSON: 'v4',
      detection: {
        excludeCacheFor: ['cimode', ...SUPPORTED_ISO_CODES]
      },
      interpolation: {
        escapeValue: false
      }
    });
} else {
  await i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      fallbackLng: FALLBACK_LANGUAGE,
      supportedLngs: SUPPORTED_ISO_CODES,
      nonExplicitSupportedLngs: true,
      backend: {
        loadPath: (lng: string, ns: string) => {
          return IS_DEV
            ? `${BUCKET_URL_BASE_DEV}/locales/${lng}/${ns}.json`
            : `${BUCKET_URL_BASE_PROD}/locales/${lng}/${ns}.json`;
        }
      },
      debug: false,
      compatibilityJSON: 'v4',
      detection: {
        excludeCacheFor: ['cimode', ...SUPPORTED_ISO_CODES]
      },
      interpolation: {
        escapeValue: false
      }
    });

  Object.entries(localResources).forEach(([lng, namespaces]) => {
    Object.entries(namespaces).forEach(([ns, resources]) => {
      i18n.addResourceBundle(lng, ns, resources, true, false);
    });
  });
}

export default i18n;
